"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Loop = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M4 12a3 3 0 013-3c.642 0 1.284.315 2.01.985.585.54 1.146 1.237 1.738 2.015-.592.778-1.153 1.475-1.739 2.015C8.284 14.685 7.642 15 7 15a3 3 0 01-3-3zm8-1.652c-.511-.654-1.054-1.298-1.634-1.833C9.466 7.685 8.358 7 7 7a5 5 0 000 10c1.358 0 2.466-.685 3.366-1.515.58-.535 1.123-1.179 1.634-1.833.511.654 1.054 1.298 1.634 1.833.9.83 2.008 1.515 3.366 1.515a5 5 0 000-10c-1.358 0-2.466.685-3.366 1.515-.58.535-1.123 1.179-1.634 1.833zM13.252 12c.592.778 1.153 1.475 1.739 2.015.725.67 1.367.985 2.009.985a3 3 0 100-6c-.642 0-1.284.315-2.01.985-.585.54-1.146 1.237-1.738 2.015z"
      }
    )
  );
};
export default Loop;
